import { imgProxyLoader } from '@doltech/utils/lib/image-loader';
import moment from 'moment';
import Image from 'next/image';
import * as React from 'react';
import styled from 'styled-components';

import { responsiveBreakPoints } from '../../../hooks/useDeviceQuery.hook';
import { colorsV2 } from '../../colors-v2';
import { Box } from '../../Common/BoxV2';
import { Separator } from '../../Layout/Landing/Content/Separator';
import { Link } from '../../Link';
import { ResponsiveTypography } from '../../Typography/v3/ResponsiveTypography';
import { NewsExtraInfo } from './NewsExtraInfo';

/* eslint-disable react/destructuring-assignment */
const Main = styled.div`
  .card-news-cover {
    border-radius: 8px;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 338px;
    @media ${responsiveBreakPoints['above-1024']} {
      height: 413px;
    }
  }
  .post-info {
    color: ${colorsV2.gray100};
    display: grid;
    grid-auto-flow: column;
    grid-auto-columns: minmax(0, max-content);
    align-items: center;
    gap: 4px;

    margin-bottom: 4px;
  }

  .description {
    color: ${colorsV2.gray100};
    white-space: pre-wrap;
  }

  .title {
    color: ${colorsV2.black100};
    + .description {
      margin-top: 8px;
    }
  }
`;

export const CardNews = (props) => {
  const { title, thumbnail, createdAt, description, page, level, topic } = props;

  return (
    <Main className="card-news">
      <div className="card-news-cover">
        <Link
          aria-label={`Read more about ${title}`}
          prefetch={false}
          href={page?.url ? `/${page?.url}` : '#'}
        >
          <Image
            alt={thumbnail?.name}
            src={thumbnail?.url || 'https://dummyimage.com/200x200.png'}
            layout="fill"
            objectFit="cover"
            loader={imgProxyLoader}
          />
        </Link>
      </div>
      <div className="card-news-content">
        <div className="post-info">
          <ResponsiveTypography.Paragraph variant="medium/14-20" color="black60">
            {moment(createdAt).locale('en').fromNow()}
          </ResponsiveTypography.Paragraph>
          <Separator variant="dot" bg="black60" width="3px" height="3px" />
          <ResponsiveTypography.Paragraph variant="medium/14-20" color="black60">
            DOL IELTS Đình Lực
          </ResponsiveTypography.Paragraph>
        </div>
        <Link
          aria-label={`Read more about ${title}`}
          prefetch={false}
          href={page?.url ? `/${page?.url}` : '#'}
        >
          <ResponsiveTypography.Paragraph
            breakpoints={[0, 768]}
            variant={['semi-bold/16', 'semi-bold/20']}
            color="black100"
            className="title"
          >
            {title}
          </ResponsiveTypography.Paragraph>
        </Link>
        {description && (
          <ResponsiveTypography.Paragraph
            variant="regular/14-20"
            mt="8px"
            ellipsis={{ rows: 3 }}
            className="description"
            color="black80"
          >
            {description}
          </ResponsiveTypography.Paragraph>
        )}
        <Box mt="8px">
          <NewsExtraInfo topic={topic} level={level} />
        </Box>
      </div>
    </Main>
  );
};
